import { getSearchParams } from '@shared/utils/search';
import { sessionAESStorage } from '@shared/utils/storage';
import { SSK } from '@shared/utils/storage/config';

import eventTracker, { LoggingAction } from '..';

interface ExposureData {
	exposure_location: string;
	appId?: string;
	app_id?: string;
	imageId?: string;
	name?: string;
	ability_name?: string;
	trace_info?: string | null;
}

type Type = 'image' | 'app' | 'banner';
class ExposureManager {
	private arr: ExposureData[] = [];
	private tempArr: ExposureData[] = [];
	private tempImageArr: ExposureData[] = [];
	private tempBannerArr: ExposureData[] = [];
	private intervals: NodeJS.Timeout | null = null;
	private intervalDuration: number = 1000; // 1秒

	constructor() {
		this.loadFromStorage();
		this.startSending();
	}

	private loadFromStorage() {
		const storedArray = sessionAESStorage.getItem(SSK.EXPOSURE_ARRAY);
		if (storedArray) {
			this.arr = JSON.parse(storedArray) as ExposureData[];
		}
	}

	add(v: ExposureData, type: Type = 'app') {
		const isDuplicate = this.arr.some(
			(item) =>
				item.exposure_location === v.exposure_location &&
				((type === 'app' && item.appId === v.appId) ||
					(type === 'image' && item.imageId === v.imageId) ||
					(type === 'banner' && item.name === v.name)),
		);
		if (isDuplicate) return;

		if (type === 'app') {
			this.tempArr.push(v);
		} else if (type === 'image') {
			this.tempImageArr.push(v);
		} else if (type === 'banner') {
			this.tempBannerArr.push(v);
		}
	}

	private startSending() {
		if (this.intervals === null) {
			this.intervals = setInterval(() => {
				this.send(), this.imageSend(), this.bannerSend();
			}, this.intervalDuration);
		}
	}

	private send() {
		if (this.tempArr.length === 0) return;
		const arrList = this.tempArr;
		eventTracker.loggingEvent(LoggingAction.EXPOSURE, { arrList, search: getSearchParams() });
		this.arr = [...this.arr, ...this.tempArr];
		sessionAESStorage.setItem(SSK.EXPOSURE_ARRAY, JSON.stringify(this.arr));
		this.tempArr = [];
	}

	private imageSend() {
		if (this.tempImageArr.length === 0) return;
		const arrList = this.tempImageArr;
		eventTracker.loggingEvent(LoggingAction.IMAGE_EXPOSURE, { arrList });
		this.arr = [...this.arr, ...this.tempImageArr];
		sessionAESStorage.setItem(SSK.EXPOSURE_ARRAY, JSON.stringify(this.arr));
		this.tempImageArr = [];
	}

	private bannerSend() {
		if (this.tempBannerArr.length === 0) return;
		const arrList = this.tempBannerArr;
		eventTracker.loggingEvent(LoggingAction.BANNER_EXPOSURE, { arrList });
		this.arr = [...this.arr, ...this.tempBannerArr];
		sessionAESStorage.setItem(SSK.EXPOSURE_ARRAY, JSON.stringify(this.arr));
		this.tempBannerArr = [];
	}

	clear() {
		this.arr = [];
		this.tempArr = [];
		this.tempImageArr = [];
		sessionAESStorage.removeItem(SSK.EXPOSURE_ARRAY);
		if (this.intervals !== null) {
			clearInterval(this.intervals);
			this.intervals = null;
		}
	}
}

const Exposure = new ExposureManager();
export default Exposure;

// import Exposure;
// Exposure.add({ location: 'exampleLocation', appId: 'exampleAppId' },'image');
